export default {
  "activityBonusHistory.title": "Activity Bonus History",
  "activityBonusHistory.copySuccess": "Copy Success!",

  "activityBonusHistory.search.createTime": "Create Time",
  "activityBonusHistory.search.rewardType": "Reward Type",
  "activityBonusHistory.search.status": "Status",

  "activityBonusHistory.column.index": "#NO",
  "activityBonusHistory.column.activityBonusId": "Activity Bonus ID",
  "activityBonusHistory.column.userno": "UserNo",
  "activityBonusHistory.column.email": "Email",
  "activityBonusHistory.column.bonusAmount": "Bonus Amount",
  "activityBonusHistory.column.bonusWager": "Bonus Wager",
  "activityBonusHistory.column.activityId": "Activity ID",
  "activityBonusHistory.column.activityType": "Activity Type",
  "activityBonusHistory.column.rewardType": "Reward Type",
  "activityBonusHistory.column.status": "Status",
  "activityBonusHistory.column.operator": "Operator",
  "activityBonusHistory.column.createTime": "Create Time",
};